import { useEffect } from 'react';
import { create } from 'zustand';

/** Header breadcrumb detail ("Triangle Talks · Ep. 41"), set by the page on screen. */
export const useCrumbStore = create<{ crumb: string | null; set: (c: string | null) => void }>()((set) => ({ crumb: null, set: (crumb) => set({ crumb }) }));

export function useCrumb(text: string | null | undefined): void {
  const set = useCrumbStore((s) => s.set);
  useEffect(() => {
    set(text ?? null);
    return () => set(null);
  }, [text, set]);
}
